import { useEffect } from "react";
import { useLocation } from "react-router-dom";

let pendingElement: HTMLElement | null = null;
let pendingPath: string | null = null;

const clearNavReturnFocus = () => {
  pendingElement = null;
  pendingPath = null;
};

export const setNavReturnFocus = (
  element: HTMLElement | null,
  path: string,
) => {
  if (!element) {
    clearNavReturnFocus();
    return;
  }
  pendingElement = element;
  pendingPath = path;
};

const isInsideMain = (node: EventTarget | null) => {
  const main = document.getElementById("main-content");
  if (!main || !(node instanceof Node)) return false;
  return node === main || main.contains(node);
};

export const useNavReturnFocus = () => {
  const location = useLocation();

  useEffect(() => {
    const currentPath = pendingPath;
    if (currentPath !== null && !location.pathname.startsWith(currentPath)) {
      clearNavReturnFocus();
    }
  }, [location.pathname]);

  useEffect(() => {
    let armed = false;
    let disarmTimer: number | undefined;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== "Tab" || !event.shiftKey || event.defaultPrevented) {
        return;
      }
      if (!pendingElement || !document.contains(pendingElement)) return;
      if (!isInsideMain(document.activeElement)) return;
      armed = true;
      window.clearTimeout(disarmTimer);
      disarmTimer = window.setTimeout(() => {
        armed = false;
      }, 0);
    };

    const handleFocusIn = (event: FocusEvent) => {
      if (!armed) return;
      armed = false;
      if (isInsideMain(event.target)) return;
      const element = pendingElement;
      if (!element || !document.contains(element)) return;
      clearNavReturnFocus();
      element.focus();
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("focusin", handleFocusIn);
    return () => {
      window.clearTimeout(disarmTimer);
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("focusin", handleFocusIn);
    };
  }, []);
};
